import React from 'react';
import { Tooltip } from '@mui/material';
import WhereToVoteIcon from '@mui/icons-material/WhereToVote';
import FmdBadIcon from '@mui/icons-material/FmdBad';
import StatusChip from './StatusChip';
import { ADDRESS_VERIFICATION_LABEL } from '../../constants/listingStatus';

/**
 * "Verified" (or "Not verified") beside a property's address in the title of its pages: the
 * property page (pages/MyPropertyDashboardPage) and, for an agent, each page of the listing
 * (components/agent/workspace/WorkspaceView), so they read the same. A StatusChip of kind
 * 'address' (constants/listingStatus.js), so its colours come from the theme's success and
 * warning roles.
 */
const AddressVerifiedChip = ({ verified }) => {
  const value = verified ? 'verified' : 'unverified';
  return (
    <Tooltip title={verified ? 'Address has been verified' : 'Address has not been verified'} arrow>
      {/* The span takes the tooltip's ref; StatusChip does not forward one. */}
      <span style={{ display: 'inline-flex' }}>
        <StatusChip
          kind="address"
          value={value}
          label={ADDRESS_VERIFICATION_LABEL[value]}
          icon={verified ? <WhereToVoteIcon /> : <FmdBadIcon />}
          size="medium"
          sx={{ ml: 1, fontWeight: 500 }}
        />
      </span>
    </Tooltip>
  );
};

export default AddressVerifiedChip;
